/**
 * DPDP Compliant Multilingual Cancellation & Refunds Content
 * Supports English and Hindi
 */

export const cancellationRefundsContent = {
    en: {
        title: "Cancellation and Refunds",
        intro: {
            p1: "We value your trust in Eternal Locker™. This Cancellation & Refunds Policy outlines the terms for cancelling subscriptions and requesting refunds for our services.",
            p2: "For more information, please also review our Terms and Conditions and Privacy Policy."
        },
        sections: {
            1: {
                title: "1. Subscription Cancellation",
                content: [
                    "You may cancel your subscription at any time from your account dashboard or by contacting our support team.",
                    "Upon cancellation, your access to Eternal Locker™ will end immediately.",
                    "No further payments will be charged after cancellation."
                ]
            },
            2: {
                title: "2. Refund Policy",
                content: [
                    "We offer a 7-day money-back guarantee for new subscriptions. If you are not satisfied, you may request a full refund within 7 days of your initial purchase.",
                    "Refund requests after 7 days from the initial purchase date will not be eligible, except as required by law.",
                    "Renewals and recurring payments are non-refundable.",
                    "Refunds will be processed to the original payment method within 7-10 business days after approval."
                ]
            },
            3: {
                title: "3. How to Request a Cancellation or Refund",
                content: [
                    "To cancel your subscription, use the cancellation option in your account dashboard or contact us at {{SUPPORT_EMAIL}}.",
                    "To request a refund, email us at {{SUPPORT_EMAIL}} with your account details and reason for the request."
                ]
            },
            4: {
                title: "4. Data Deletion Upon Cancellation",
                content: [
                    "Upon subscription cancellation or refund approval, your account access is immediately terminated.",
                    "Your personal data will be deleted in accordance with our data retention policy (typically within 6 months post-deletion).",
                    "Audit logs may be retained for legal compliance purposes (60 days retention).",
                    "You will receive confirmation when your account and associated data have been purged."
                ]
            },
            5: {
                title: "5. Exceptions",
                content: [
                    "Refunds may not be provided for accounts found to be in violation of our Terms and Conditions or for misuse of the service.",
                    "We reserve the right to refuse a refund if we determine abuse of our refund policy.",
                    "Statutory rights under applicable consumer protection laws will supersede this policy where applicable."
                ]
            },
            6: {
                title: "6. Changes to This Policy",
                content: [
                    "We may update this Cancellation & Refunds Policy from time to time. Changes will be posted on this page, and your continued use of the service constitutes acceptance of the revised policy."
                ]
            },
            7: {
                title: "7. Statutory Rights",
                content: [
                    "This policy is applied subject to rights and remedies available under applicable law.",
                    "Where mandatory legal protections apply, those protections will prevail over conflicting policy terms."
                ]
            },
            8: {
                title: "8. Contact Us",
                content: "If you have any questions or concerns about this policy, please contact us at {{SUPPORT_EMAIL}}."
            }
        }
    },
    hi: {
        title: "रद्दीकरण और रिफंड",
        intro: {
            p1: "हम Eternal Locker™ में आपके विश्वास की सराहना करते हैं। यह रद्दीकरण और रिफंड नीति सदस्यता रद्द करने और हमारी सेवाओं के लिए रिफंड का अनुरोध करने की शर्तों को बताती है।",
            p2: "अधिक जानकारी के लिए, कृपया हमारी शर्तें और शर्तें और गोपनीयता नीति भी देखें।"
        },
        sections: {
            1: {
                title: "1. सदस्यता रद्दीकरण",
                content: [
                    "आप अपनी खाता डैशबोर्ड से किसी भी समय अपनी सदस्यता रद्द कर सकते हैं या हमारी सहायता टीम से संपर्क कर सकते हैं।",
                    "रद्दीकरण के बाद, Eternal Locker™ तक आपकी पहुंच तुरंत समाप्त हो जाएगी।",
                    "रद्दीकरण के बाद कोई और भुगतान नहीं किया जाएगा।"
                ]
            },
            2: {
                title: "2. रिफंड नीति",
                content: [
                    "हम नई सदस्यता के लिए 7-दिन की मनी-बैक गारंटी प्रदान करते हैं। यदि आप संतुष्ट नहीं हैं, तो आप अपनी प्रारंभिक खरीद के 7 दिनों के भीतर पूर्ण रिफंड का अनुरोध कर सकते हैं।",
                    "प्रारंभिक खरीद तारीख के बाद 7 दिनों के बाद रिफंड अनुरोध पात्र नहीं होंगे, सिवाय इसके कि कानून द्वारा आवश्यक हो।",
                    "नवीनीकरण और आवर्ती भुगतान गैर-वापसी योग्य हैं।",
                    "रिफंड मंजूरी के बाद 7-10 व्यावसायिक दिनों के भीतर मूल भुगतान विधि में संसाधित किए जाएंगे।"
                ]
            },
            3: {
                title: "3. रद्दीकरण या रिफंड का अनुरोध कैसे करें",
                content: [
                    "अपनी सदस्यता रद्द करने के लिए, अपनी खाता डैशबोर्ड में रद्दीकरण विकल्प का उपयोग करें या {{SUPPORT_EMAIL}} पर हमसे संपर्क करें।",
                    "रिफंड का अनुरोध करने के लिए, {{SUPPORT_EMAIL}} पर हमें अपने खाते का विवरण और अनुरोध के कारण के साथ ईमेल करें।"
                ]
            },
            4: {
                title: "4. रद्दीकरण पर डेटा हटाना",
                content: [
                    "सदस्यता रद्दीकरण या रिफंड अनुमोदन के बाद, आपकी खाता पहुंच तुरंत समाप्त हो जाती है।",
                    "आपका व्यक्तिगत डेटा हमारी डेटा प्रतिधारण नीति के अनुसार हटा दिया जाएगा (आमतौर पर हटाने के 6 महीने के भीतर)।",
                    "कानूनी अनुपालन उद्देश्यों के लिए ऑडिट लॉग प्रतिधारित किए जा सकते हैं (60 दिन की प्रतिधारण)।",
                    "जब आपके खाते और संबंधित डेटा को समाप्त कर दिया गया हो तो आप पुष्टि प्राप्त करेंगे।"
                ]
            },
            5: {
                title: "5. अपवाद",
                content: [
                    "रिफंड उन खातों के लिए प्रदान नहीं किए जा सकते हैं जो हमारी शर्तों और शर्तों का उल्लंघन करते हुए या सेवा के दुरुपयोग के लिए पाए जाते हैं।",
                    "यदि हम हमारी रिफंड नीति का दुरुपयोग निर्धारित करते हैं तो हम रिफंड से इनकार करने का अधिकार सुरक्षित रखते हैं।",
                    "लागू उपभोक्ता संरक्षण कानूनों के तहत सांविधिक अधिकार जहां लागू हों, इस नीति से प्रभावी होंगे।"
                ]
            },
            6: {
                title: "6. इस नीति में परिवर्तन",
                content: [
                    "हम समय-समय पर इस रद्दीकरण और रिफंड नीति को अपडेट कर सकते हैं। परिवर्तन इस पृष्ठ पर पोस्ट किए जाएंगे, और सेवा का आपका निरंतर उपयोग संशोधित नीति की स्वीकृति का प्रतিनिधित्व करता है।"
                ]
            },
            7: {
                title: "7. सांविधिक अधिकार",
                content: [
                    "यह नीति लागू कानून के तहत उपलब्ध अधिकारों और उपचारों के अधीन लागू की जाती है।",
                    "जहां अनिवार्य कानूनी सुरक्षा लागू होती है, वह सुरक्षा विरोधी नीति शर्तों पर प्रबल होगी।"
                ]
            },
            8: {
                title: "8. हमसे संपर्क करें",
                content: "यदि आपके पास इस नीति के बारे में कोई सवाल या चिंता है, तो कृपया हमसे {{SUPPORT_EMAIL}} पर संपर्क करें।"
            }
        }
    }
};

export function getCancellationRefundsContent(lang = 'en') {
    return cancellationRefundsContent[lang] || cancellationRefundsContent.en;
}

export function getAvailableLanguagesForCancellation() {
    return Object.keys(cancellationRefundsContent);
}
